import { StatisticsAreaGranularityEnum } from '@model/enum/statistics-granularity.enum';
import { useCpmsBoGetEnergyDeliveredByChargePointQuery } from '@service/cpms-bo-transaction-reports-energy-statistics.service';

import {
  MoreLessCard,
  MoreLessCardVariantEnum,
} from '../../components/more-less-card/more-less.card';
import { useFilters } from '../../context/filters.context';

export const MoreLessEnergyChargePointCard = (): React.JSX.Element | null => {
  const {
    transformedFilters,
    filters: { areaGranularity },
  } = useFilters();

  const { data } = useCpmsBoGetEnergyDeliveredByChargePointQuery({
    ...transformedFilters,
  });

  return areaGranularity !== StatisticsAreaGranularityEnum.ChargePoint ? (
    <MoreLessCard data={data} variant={MoreLessCardVariantEnum.Energy} />
  ) : null;
};
